import { ArrowRight } from "lucide-react";
import { imgSrc } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/smoothScroll";
import { useLang } from "@/context/LanguageContext";

const PHOTOS = {
  main: "/api/files/bertagnolli-site/uploads/7485d10f-c57c-4d5a-9308-2e7f677c31e9.jpg",
  secondary: "/api/files/bertagnolli-site/uploads/819a81b0-6def-4e1e-8c6a-18cf86f93639.jpg",
};

export default function OltreLoSport() {
  const { t } = useLang();

  return (
    <section id="oltre-lo-sport" className="py-12 sm:py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <span className="text-xs uppercase tracking-[0.3em] font-semibold text-sky-400">{t("oltre.eyebrow")}</span>
              <h2 className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl text-slate-50 leading-[0.95]">
                {t("oltre.titleA")}<br /><span className="text-amber-400">{t("oltre.titleAccent")}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-4 text-base sm:text-lg text-slate-300 font-light">
                {t("oltre.lead")}
              </p>
              <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">
                {t("oltre.body")}
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <button
                  data-testid="oltre-sport-cta"
                  onClick={() => scrollToSection("#collaborazioni")}
                  className="group inline-flex items-center gap-3 rounded-full border border-amber-400/60 px-7 py-3.5 text-xs font-bold uppercase tracking-[0.2em] text-amber-400 transition-colors duration-300 hover:bg-amber-400 hover:text-[#090D14]"
                >
                  {t("oltre.cta")}
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </button>
                <button
                  data-testid="oltre-sport-cta-contatti"
                  onClick={() => scrollToSection("#contatti")}
                  className="group inline-flex items-center gap-3 rounded-full bg-sky-400 px-7 py-3.5 text-xs font-bold uppercase tracking-[0.2em] text-[#090D14] transition-all duration-300 hover:bg-sky-300 hover:scale-[1.03]"
                >
                  {t("oltre.ctaContact")}
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </button>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 relative">
            <Reveal x={40} y={0}>
              <div className="relative">
                <div className="overflow-hidden rounded-2xl border border-slate-800/80 rotate-1">
                  <img src={imgSrc(PHOTOS.main, 960)} alt={t("oltre.altA")} loading="lazy" className="w-full aspect-[4/3] object-cover" style={{ objectPosition: "50% 45%" }} />
                </div>
                <div className="absolute -bottom-8 -left-4 sm:-left-8 w-40 sm:w-52 overflow-hidden rounded-xl border border-amber-400/40 shadow-[0_20px_60px_rgba(0,0,0,0.6)] -rotate-2">
                  <img src={imgSrc(PHOTOS.secondary, 400)} alt={t("oltre.altB")} loading="lazy" className="w-full aspect-square object-cover" />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
